import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageModalComponent } from 'src/app/shared/components/message-modal/message-modal.component';

@Injectable({
  providedIn: 'root'
})

export class MessageService {

  constructor(
    public dialogService: DialogService,
    public dialogRef: DynamicDialogRef
  ) { }

  showPopup(content: any, tip: string, contentType?: string, css?: string, errorInfo?: any[], width?: string): any {


    const dialogRef = this.dialogService.open(MessageModalComponent, {
      data: {
        tip: tip,
        Content: content,
        ContentType: contentType ? contentType : '',
        ErrorInfo: errorInfo
      },
      showHeader: false,
      // PrimeNG stacks a dialog at baseZIndex + a global counter, so ties break
      // in favour of whatever opened last but a LOWER base always loses. Every
      // payment/bet dialog opens at 10000 (crypto transactions at 30000), and
      // this popup used to take the default 0 — which is why an alert raised
      // from inside a modal (a failed withdrawal, "your deposit already
      // landed") rendered BEHIND the modal that raised it. Matching the highest
      // base in the app keeps an alert on top of anything that can open it.
      baseZIndex: 30000
    });



    // const dialogRef = this.dialog.open(
    //   MessageModalComponent,
    //   {
    //     panelClass: css ? css : '',
    //     width: width ? width : '',
    //     data: {
    //       Content: content,
    //       ContentType: contentType ? contentType : ''
    //     }
    //   });
    // dialogRef.componentInstance.tip = tip;
    // return dialogRef;
  }
  hideModal(): any {
    this.dialogRef.close();

  }
}
